import { Check, ArrowRight, Star } from 'lucide-react';

/**
 * Tarjeta de un plan de precios: nombre y lema, precio, descripción, ventajas,
 * nota al pie y botón. El plan destacado va en oscuro y algo más elevado.
 */
export default function PlanCard({ plan, revealed, delay, onSelect }) {
  const dark = plan.highlight;

  return (
    <div
      className={`relative flex flex-col rounded-3xl p-8 transition-all duration-500 ${
        dark
          ? 'bg-gray-950 text-white shadow-2xl shadow-violet-500/20 lg:-translate-y-4 border border-white/10'
          : 'bg-white border border-gray-100 shadow-sm hover:shadow-lg hover-lift'
      } ${revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      style={{ transitionDelay: revealed ? '0ms' : delay }}
    >
      {plan.badge && (
        <span className="absolute top-5 right-5 inline-flex items-center gap-1 rounded-full bg-brand-blue text-white text-[10px] font-black uppercase tracking-widest px-3 py-1">
          <Star size={10} /> {plan.badge}
        </span>
      )}

      <div className="flex items-center gap-2 mb-5">
        <h3 className="font-heading font-black text-sm uppercase tracking-widest text-brand-blue">{plan.name}</h3>
        <span className={`w-1 h-1 rounded-full ${dark ? 'bg-white/30' : 'bg-gray-300'}`} />
        <span className={`text-[11px] font-bold uppercase tracking-widest ${dark ? 'text-white/40' : 'text-gray-400'}`}>
          {plan.tag}
        </span>
      </div>

      <div className="flex items-end gap-1.5 mb-3">
        <span className={`font-heading font-black text-4xl lg:text-5xl tracking-tight ${dark ? 'text-white' : 'text-gray-900'}`}>
          {plan.price}
        </span>
        <span className={`text-sm font-medium pb-2 ${dark ? 'text-white/50' : 'text-gray-400'}`}>{plan.period}</span>
      </div>

      <p className={`text-sm font-light mb-6 pb-6 border-b ${dark ? 'text-white/60 border-white/10' : 'text-gray-500 border-gray-100'}`}>
        {plan.blurb}
      </p>

      <ul className="space-y-3 mb-6">
        {plan.features.map((feature, i) => (
          <li key={i} className="flex items-start gap-2.5">
            <div className="w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-0.5" style={{ background: `${plan.color}20` }}>
              <Check size={11} style={{ color: plan.color }} strokeWidth={3} />
            </div>
            <span className={`text-sm font-light ${dark ? 'text-white/80' : 'text-gray-600'}`}>{feature}</span>
          </li>
        ))}
      </ul>

      <p className={`text-xs font-light italic leading-relaxed mb-6 ${dark ? 'text-white/40' : 'text-gray-400'}`}>{plan.note}</p>

      <button
        onClick={onSelect}
        className={`mt-auto w-full py-3.5 rounded-xl font-bold text-sm transition-all flex items-center justify-center gap-2 ${
          dark
            ? 'bg-brand-violet text-white hover:opacity-90 hover:scale-105 shadow-lg shadow-violet-500/30'
            : 'bg-gray-900 text-white hover:bg-gray-800'
        }`}
      >
        {plan.cta} <ArrowRight size={14} />
      </button>
    </div>
  );
}